const { __ } = wp.i18n;
const { useEffect } = wp.element;
const { TabPanel, Panel, PanelBody, PanelRow, TextControl, __experimentalUnitControl: UnitControl, Button } = wp.components;
const { InspectorControls } = wp.blockEditor;

import BUnit from "../components/BUnit";
import BMediaUpload from "../components/BMediaUpload/BMediaUpload";
import panelBodyController from "../../../../utils/panelBodyController";
import poster from "../../img/sticky-default.jpg";

const Settings = (props) => {
  const {
    props: { attributes, setAttributes, isSelected },
  } = props;
  const { audios, theme, width, height, posterHeight } = attributes;

  const handleList = (property, value, index) => {
    const newAudios = [...audios];
    newAudios[index][property] = value;
    setAttributes({ audios: newAudios });
  };

  useEffect(() => {
    panelBodyController();
  }, [isSelected]);

  const handleAddItem = () => {
    const newAudios = [...audios];
    newAudios.push({
      title: "audio tile",
      poster,
      source: "",
      artist: "artist",
    });
    setAttributes({ audios: newAudios });
  };

  return (
    <InspectorControls style={{ marginBottom: "40px" }}>
      <TabPanel
        className="bPSS"
        activeClass="active-tab"
        onSelect={() => {
          panelBodyController();
        }}
        tabs={[
          {
            name: "content",
            title: "Content",
            className: "content btTab",
          },
          {
            name: "settings",
            title: "Settings",
            className: "settings btTab",
          },
        ]}
      >
        {(tab) => {
          return (
            <span>
              {tab.name == "content" && (
                <span>
                  <Panel>
                    {audios.map(({ source, artist, poster, title }, index) => (
                      <PanelBody key={index} title={title} initialOpen={false}>
                        <BMediaUpload value={source} onSelect={(source) => handleList("source", source, index)} type={["audio"]} label={__("Source", "h5ap")} />

                        <BMediaUpload value={poster} onSelect={(poster) => handleList("poster", poster, index)} type={["image"]} label={__("Thumbnail", "h5ap")} />

                        <PanelRow>
                          <TextControl placeholder={__("Title", "h5ap")} value={title} onChange={(title) => handleList("title", title, index)} />
                        </PanelRow>
                        <PanelRow>
                          <TextControl placeholder={__("Artist", "h5ap")} value={artist} onChange={(artist) => handleList("artist", artist, index)} />
                        </PanelRow>
                        {/* <Button onClick={() => handleDuplicateItem(index)}>{__("Duplicate", "h5ap")}</Button> */}
                        {/* <Button onClick={() => handleRemoveItem(index)}>{__("Remove", "h5ap")}</Button> */}
                        <div className="d-flex w-full">
                          <Button
                            icon="trash"
                            className="trash"
                            onClick={() => {
                              setAttributes({ audios: audios.filter((item, itemIndex) => index !== itemIndex) });
                            }}
                          ></Button>
                        </div>
                      </PanelBody>
                    ))}
                    <PanelRow>
                      <Button variant="primary" onClick={handleAddItem}>
                        {__(" Add New", "h5ap")}
                      </Button>
                    </PanelRow>
                  </Panel>
                </span>
              )}
              {tab.name == "settings" && (
                <span>
                  <Panel>
                    <PanelBody>
                      <PanelRow className="skin">
                        <label className="label">{__("Theme", "h5ap")}</label>
                        <BUnit value={theme} units={["Light", "Dark"]} onChange={(theme) => setAttributes({ theme })} />
                      </PanelRow>

                      <PanelRow>
                        <UnitControl
                          label={__("Width", "h5ap")}
                          labelPosition="side"
                          units={[
                            { value: "px", label: "px", default: 500 },
                            { value: "%", label: "%", default: 100 },
                          ]}
                          onChange={(width) => setAttributes({ width })}
                          value={typeof width === "object" ? `${width.number}${width.unit}` : width}
                          isResetValueOnUnitChange={true}
                        />
                      </PanelRow>

                      <PanelRow>
                        <UnitControl
                          label={__("Height", "h5ap")}
                          labelPosition="side"
                          units={[
                            { value: "px", label: "px", default: 500 },
                            { value: "%", label: "%", default: 100 },
                          ]}
                          onChange={(height) => setAttributes({ height })}
                          value={typeof height === "object" ? `${height.number}${height.unit}` : height}
                          isResetValueOnUnitChange={true}
                        />
                      </PanelRow>
                      <PanelRow>
                        <UnitControl
                          label={__("Thumbnail Height", "h5ap")}
                          labelPosition="side"
                          units={[
                            { value: "px", label: "px", default: 500 },
                            { value: "%", label: "%", default: 100 },
                          ]}
                          onChange={(posterHeight) => setAttributes({ posterHeight })}
                          value={typeof posterHeight === "object" ? `${posterHeight.number}${posterHeight.unit}` : posterHeight}
                          isResetValueOnUnitChange={true}
                        />
                      </PanelRow>
                    </PanelBody>
                  </Panel>
                </span>
              )}
            </span>
          );
        }}
      </TabPanel>
    </InspectorControls>
  );
};

export default Settings;
